import { useCallback, useRef } from 'react';
import type { MouseEvent } from 'react';

interface UsePreventDoubleClickOptions {
  delay?: number;
}

function usePreventDoubleClick(options: UsePreventDoubleClickOptions = {}) {
  const { delay = 1000 } = options;
  const lastClickRef = useRef<number>(0);

  const preventDoubleClick = useCallback(
    <T extends HTMLElement = HTMLElement>(callback?: (event: MouseEvent<T>) => void) => {
      return (event: MouseEvent<T>) => {
        const now = Date.now();
        const timeDiff = now - lastClickRef.current;

        if (timeDiff < delay) {
          // 一定時間内の2回目以降のクリック → preventDefault
          event.preventDefault();
          console.log('ダブルクリックを防止しました');
          return;
        }

        // 1回目のクリック または 一定時間経過後のクリック
        lastClickRef.current = now;

        // コールバックが指定されている場合は実行
        if (callback) {
          callback(event);
        }
        // コールバックが指定されていない場合は、デフォルト動作（リンク遷移）を許可
      };
    },
    [delay]
  );

  return preventDoubleClick;
}

export default usePreventDoubleClick;
